/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".image-gallery-overlay-container{width:calc(100% - 50px);height:calc(100% - 50px)}.image-gallery-overlay-backdrop{background:rgba(0,0,0,.8)}image-gallery-overlay{display:block;width:100%;height:100%;position:relative}image-gallery-overlay media-image{display:block;box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12);border-radius:4px;background-color:#000;overflow:hidden}image-gallery-overlay .close-button{position:absolute;top:-15px;right:-15px}"];
export { styles as styles };
